import userPasswordSection from "../../components/userPasswordSection/index.vue";

export default {
  name: "userPassword",
  components: {
    userPasswordSection,
  },
};
